import { ArrowRight, Truck } from "lucide-react"
import { type PushProduct, num } from "../data"
import { shortDate } from "../dates"
import { afterIncoming, sitesOf } from "../stock"
import SitesTable from "./SitesTable"

// Stock per warehouse, so the room can see stock stuck where nothing moves
// and decide to move it rather than promote it. The incoming order sits
// underneath.
export default function WhereItSits({ product }: { product: PushProduct }) {
  const rows = sitesOf(product).map((s) => ({ warehouse: s.warehouse, qty: s.qty, move: s.outPerDay }))
  const incoming = afterIncoming(product)

  return (
    <div className="overflow-hidden rounded-md border">
      <SitesTable rows={rows} />
      <div className="flex items-center gap-2 border-t px-4 py-2.5 text-sm">
        <Truck className="h-4 w-4 shrink-0" />
        {incoming ? (
          <span className="flex flex-wrap items-center gap-x-1.5">
            Incoming: <span className="font-semibold tabular-nums">{num(incoming.qty)}</span> on {shortDate(incoming.arrives)}
            <ArrowRight className="h-3.5 w-3.5" />
            stock lasts <span className="font-semibold tabular-nums">{incoming.lasts === null ? "—" : `${num(incoming.lasts)} days`}</span> after it lands
          </span>
        ) : (
          <span>No incoming orders</span>
        )}
      </div>
    </div>
  )
}
